import { SET_PAYMENT_PLANS } from '../mutation-types'
import helperApi from '../../api/HelperApi'

const state = {
  paymentPlans: []
}

const getters = {
  paymentPlansList: state => state.paymentPlans
}

const actions = {
  async setPaymentPlans ({ state, commit }) {
    if (state.paymentPlans.length) return

    try {
      const paymentPlans = await helperApi.getPaymentPlans()
      commit(SET_PAYMENT_PLANS, paymentPlans)
      return paymentPlans
    } catch (e) {
      return e
    }
  }
}

const mutations = {
  [SET_PAYMENT_PLANS] (state, paymentPlans) {
    state.paymentPlans = paymentPlans
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
